import React from "react";
import { useAppSelector } from "hooks/redux";
import moment from "moment";
import { convertTime } from "helpers/Helpers";

import { ITournament } from "redux/reducers/models/tournament";
import { ILeague } from "redux/reducers/models/league";
import { ITeeTimeNew } from "redux/reducers/models/teetime";

import "./cartOption2Preview.scss";

interface ICartSignPreview {
  event: ITournament | ILeague;
  teetime: ITeeTimeNew;
}

export default function CartOption2Preview(props: ICartSignPreview) {
  const facilityStore = useAppSelector(store => store.facilityStore);

  return (
    <div className="cart-sign-2-container">
      <div>
        <div className="header">
          <div className="header-logo-container">
            <img className="header-logo" src={facilityStore.facility?.logo_source} />
          </div>
          <div className="header-info">
            <div className="event-name">{props.event?.name}</div>
            <div className="course-name">
              {
                facilityStore.facility?.courses.find(course => course.id === props.teetime.slots[0].course_id)
                  ?.long_name
              }
            </div>
            <div className="division-names">
              {
                facilityStore.facility?.courses[0]?.divisions.find(
                  division => division.id === props.teetime.slots[0].division_id,
                )?.title
              }
              {" to "}
              {
                facilityStore.facility?.courses[0]?.divisions.find(
                  division => division.id === props.teetime.slots[0].turn_division_id,
                )?.title
              }
            </div>
          </div>
          <div className="header-logo-container"></div>
        </div>
        <div className="players">
          <div className="player-name">
            {props.teetime.slots[0].booking_participant_id
              ? `${props.teetime.slots[0].customer_first_name}  ${props.teetime.slots[0].customer_last_name}`
              : " "}
          </div>

          <div className="player-name">
            {props.teetime.slots[1].booking_participant_id
              ? `${props.teetime.slots[1].customer_first_name}  ${props.teetime.slots[1].customer_last_name}`
              : " "}
          </div>
        </div>
        <div className="footer">
          <div className="footer-group">
            <div className="footer-header">Time</div>
            <div className="footer-content">{convertTime(props.teetime.start_time)}</div>
          </div>
          <div className="footer-group">
            <div className="footer-header">Date</div>
            <div className="footer-content">{moment(props.teetime.slots[0].date).format("MMM D")}</div>
          </div>
          <div className="footer-group">
            <div className="footer-header">Hole</div>
            <div className="footer-content">{props.teetime.slots[0].start_hole}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
